import React from 'react';

const GameContext = React.createContext();

export default GameContext;